export const initialState = {
    loggedIn:false,
    currentPage:"home",
    loginInfo:{},
    allResourceData: [],
    allRequestData: [],
}

const reducer = (state, action) => {

    switch(action.type){
        case 'LOGIN_USER': 
            return {
                ...state,
                loggedIn:true,
                loginInfo:action.userData,
            }
        case 'LOGOUT_USER': 
            return {
                ...state,
                loggedIn:false,
                loginInfo:action.userData,
                currentPage: "home"
            }

        case 'UPDATE_PAGE': 
            return {
                ...state,
                currentPage:action.page,
            }
        case 'UPDATE_ALL_RESOURCE_DATA': 
            return {
                ...state,
                allResourceData:action.data,
                allRequestData:action.requests,
            }
        default : return state;
    }
}

export default reducer